
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerNorth as ObiBeaconTowerNorthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-north.js';
 
 
 

 
 export const ObiBeaconTowerNorth = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-north',
   elementClass: ObiBeaconTowerNorthElement,
   events: {
     
   }
  });
 
 